<script>
    import { NICHE_TEMPLATES, getNicheTemplate } from '../../data/nicheTemplates.js';
    import Icon from '../icons/Icon.svelte';

    export let isOpen = false;
    export let currentNicheId = 'hamburgueria';
    export let onSelectNiche = () => {};
    export let onClose = () => {};

    let selectedId = currentNicheId || 'hamburgueria';
    let reimportComplements = false;

    $: activeTemplate = getNicheTemplate(selectedId);

    function handleApply() {
        onSelectNiche({
            nicheId: selectedId,
            template: activeTemplate,
            reimportComplements
        });
        onClose();
    }
</script>

{#if isOpen}
    <div class="modal-overlay" on:click|self={onClose}>
        <div class="modal-card">
            <header class="modal-header">
                <div class="header-info">
                    <span class="modal-badge">SEGMENTO GASTRONÔMICO</span>
                    <h2>Escolha o Ramo do seu Estabelecimento</h2>
                    <p>O ramo ajusta automaticamente as cores da loja, mensagens do WhatsApp e padrões de pedidos.</p>
                </div>
                <button type="button" class="btn-close" on:click={onClose}>
                    <Icon name="x" size={18} />
                </button>
            </header>

            <div class="niches-grid">
                {#each NICHE_TEMPLATES as niche}
                    <button
                        type="button"
                        class="niche-card {selectedId === niche.id ? 'active' : ''}"
                        on:click={() => selectedId = niche.id}
                    >
                        <div class="niche-header">
                            <div class="niche-icon-box" style="background: {niche.themeColor}22; color: {niche.themeColor};">
                                <Icon name={niche.svgIcon || 'utensils'} size={24} />
                            </div>
                            {#if niche.badge}
                                <span class="niche-badge" style="background: {niche.themeColor}25; color: {niche.themeColor}; border: 1px solid {niche.themeColor}44;">
                                    {niche.badge}
                                </span>
                            {/if}
                        </div>

                        <h3 class="niche-name">{niche.name}</h3>
                        <p class="niche-desc">{niche.description}</p>

                        <div class="niche-footer">
                            <span class="preset-tag">
                                <Icon name="layers" size={12} />
                                {niche.groups ? niche.groups.length : 0} grupos de adicionais
                            </span>
                        </div>
                    </button>
                {/each}
            </div>

            <!-- Opções adicionais de importação -->
            <div class="niche-options-box">
                <label class="checkbox-option">
                    <input type="checkbox" bind:checked={reimportComplements} />
                    <span class="checkbox-label">
                        <strong>Reimportar complementos e adicionais padrão deste ramo</strong>
                        <small>Adiciona ao seu cardápio os grupos típicos (ex: tamanhos de pizza, pontos da carne, etc.) sem apagar seus itens existentes.</small>
                    </span>
                </label>
            </div>

            <footer class="modal-footer">
                <button type="button" class="btn-cancel" on:click={onClose}>
                    Cancelar
                </button>
                <button type="button" class="btn-confirm" on:click={handleApply}>
                    <Icon name="check" size={16} />
                    <span>Aplicar Ramo Selecionado</span>
                </button>
            </footer>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.5);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 16px;
        width: 100%;
        max-width: 820px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    .modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 24px;
        border-bottom: 1px solid #E2E8F0;
        background: #FFFFFF;
    }

    .modal-badge {
        font-size: 0.7rem;
        font-weight: 700;
        color: #FF6A00;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        display: block;
        margin-bottom: 4px;
    }

    .modal-header h2 {
        font-size: 1.25rem;
        font-weight: 700;
        color: #0F172A;
        margin: 0 0 4px 0;
    }

    .modal-header p {
        font-size: 0.84rem;
        color: #64748B;
        margin: 0;
    }

    .btn-close {
        background: none;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 6px;
        border-radius: 8px;
        transition: all 0.2s;
    }

    .btn-close:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .niches-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 14px;
        padding: 20px 24px;
        overflow-y: auto;
        flex: 1;
        background: #F8FAFC;
    }

    .niche-card {
        background: #FFFFFF;
        border: 1.5px solid #E2E8F0;
        border-radius: 12px;
        padding: 16px;
        text-align: left;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        flex-direction: column;
    }

    .niche-card:hover {
        border-color: #FF6A00;
        background: #FFFBF7;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }

    .niche-card.active {
        border-color: #FF6A00;
        background: #FFF7ED;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.25);
    }

    .niche-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }

    .niche-icon-box {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .niche-badge {
        font-size: 0.68rem;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 6px;
    }

    .niche-name {
        font-size: 0.98rem;
        font-weight: 700;
        color: #0F172A;
        margin: 0 0 6px 0;
    }

    .niche-desc {
        font-size: 0.8rem;
        color: #64748B;
        margin: 0 0 14px 0;
        line-height: 1.35;
        flex: 1;
    }

    .niche-footer {
        border-top: 1px solid #F1F5F9;
        padding-top: 10px;
    }

    .preset-tag {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 0.72rem;
        color: #64748B;
    }

    .niche-options-box {
        padding: 14px 24px;
        background: #FFFFFF;
        border-top: 1px solid #E2E8F0;
    }

    .checkbox-option {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        cursor: pointer;
    }

    .checkbox-option input {
        margin-top: 3px;
        accent-color: #FF6A00;
        width: 16px;
        height: 16px;
    }

    .checkbox-label {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .checkbox-label strong {
        font-size: 0.86rem;
        color: #0F172A;
    }

    .checkbox-label small {
        font-size: 0.76rem;
        color: #64748B;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding: 16px 24px;
        border-top: 1px solid #E2E8F0;
        background: #FFFFFF;
    }

    .btn-cancel {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 9px 18px;
        border-radius: 8px;
        font-size: 0.86rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-confirm {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #FFFFFF;
        padding: 9px 20px;
        border-radius: 8px;
        font-size: 0.86rem;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
        transition: all 0.2s;
    }

    .btn-confirm:hover {
        background: #EA580C;
    }
</style>
